import React, { FC, useMemo } from "react";
import { FilterOption, FilterType, GeneralFacet } from "../types";
import FilterSizeContainerMob from "./filterSizeContainerMob";
import { resolveAdvancedData, resolveSimpleData } from "../utils";

const FilterSizeMob: FC<{
  filter: GeneralFacet & { data: FilterOption[] | any };
  setToggledFilter: (filter: FilterType | EmptyObject) => void;
  toggledFilter: FilterType;
}> = ({ filter, setToggledFilter, toggledFilter }) => {
  const advancedData = useMemo(
    () => resolveAdvancedData(filter.data),
    [filter.data]
  );
  const simpleData = useMemo(
    () => resolveSimpleData(filter.data),
    [filter.data]
  );

  return (
    <FilterSizeContainerMob
      filter={filter}
      simpleGroups={Array.isArray(simpleData) ? simpleData : []}
      advancedGroups={Array.isArray(advancedData) ? advancedData : []}
    />
  );
};

export default FilterSizeMob;
